export const inputMaskData = [
    {
      text: "Input Mask Used In Form-Validations,Forms,Card-Details,And Etc.",
    },
  ];